
<ng-container *transloco="let t; read: 'common'">
<div class="modal-header">
    <h4 class="modal-title" id="modal-title">Filtrar archivos</h4>
    <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div *ngIf="modalMode === 'both' && searchMode === 0" style="margin-top: 2rem;" class="row">
    <div class="col col-lg-9 col-12">
      <label for="search"><b>{{t('quick_search')}}</b></label>
      <div style="margin-top: -1rem; margin-left: 1rem; display: inline"><small><a (click)="changeSearchMode()" [routerLink]="">{{t('advanced_search')}}</a></small></div>
      <input type="text" [(ngModel)]="quickSearchString" class="form-control" id="search" placeholder="{{t('quick_search_placeholder')}}">
    </div>
  </div> 

  <div *ngIf="searchMode === 1" style="margin-top: 2rem;" class="row">
    <div *ngIf="modalMode === 'both'" class="col col-9 col-lg-9 col-12">
      <label for="search"><b>{{t('advanced_search')}}</b></label>
      <div style="margin-top: -1rem; margin-left: 1rem; display: inline"><small><a (click)="changeSearchMode()" [routerLink]="">{{t('quick_search')}}</a></small></div>
    </div>

    <div class="col col-12">
      <div class="row">
        <div class="col col-12">
          <form>
            <div class="form-row">
              <div class="form-group col-12 col-lg-4">
                <label for="title">{{t('title')}}</label>
                <input [(ngModel)]="formAdvancedSearch.title" class="form-control" id="title" name="title"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="keywords">{{t('key_words')}}</label>
                <input [(ngModel)]="formAdvancedSearch.keywords" class="form-control" id="keywords" name="keywords"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="coverage">{{t('coverage')}}</label>
                <input [(ngModel)]="formAdvancedSearch.coverage" class="form-control" id="coverage" name="coverage"
                       type="text">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 col-lg-4">
                <label for="description">{{t('description')}}</label>
                <input [(ngModel)]="formAdvancedSearch.description" class="form-control" id="description" name="description"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="source">{{t('source')}}</label>
                <input [(ngModel)]="formAdvancedSearch.source" class="form-control" id="source" name="source"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="multimedia-type">{{t('resource_type')}}</label>

                <select [(ngModel)]="formAdvancedSearch.multimedia_type" class="form-control" id="multimedia-type" name="multimedia-type">
                  <option [value]="''"></option>
                  <option [value]="'photo'">{{t('photo')}}</option>
                  <option [value]="'audio'">{{t('audio')}}</option>
                  <option [value]="'video'">{{t('video')}}</option>
                  <option [value]="'document'">{{t('document')}}</option>
                </select>

              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 col-lg-4">
                <label for="author">{{t('author')}}</label>
                <input [(ngModel)]="formAdvancedSearch.author" class="form-control" id="author" name="author"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="publisher">Publisher</label>
                <input [(ngModel)]="formAdvancedSearch.publisher" class="form-control" id="publisher" name="publisher"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="coordinates">{{t('coordinates')}}</label>
                <input [(ngModel)]="formAdvancedSearch.coordinates" class="form-control" id="coordinates" name="coordinates"
                       type="text">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-12 col-lg-4">
                <label for="categories">{{t('category')}}</label>
                <input [(ngModel)]="formAdvancedSearch.categories" class="form-control" id="categories" name="categories"
                       type="text">
              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="format">{{t('format')}}</label>

                <select [(ngModel)]="formAdvancedSearch.format" class="form-control" id="format" name="format">
                  <option [value]="''"></option>
                  <option [value]="'mp3'">mp3</option>
                  <option [value]="'mp4'">mp4</option>
                  <option [value]="'jpg'">jpg</option>
                  <option [value]="'pdf'">pdf</option>
                </select>

              </div>
              <div class="form-group col-12 col-lg-4">
                <label for="rights">{{t('license')}}</label>

                <select [(ngModel)]="formAdvancedSearch.rights" class="form-control" id="rights" name="rights">
                  <option [value]="''"></option>
                  <option [value]="'NO'">{{t('no_license')}}</option>
                  <option [value]="'CC BY'">Reconocimiento - CC BY</option>
                  <option [value]="'CC BY-SA'">Reconocimiento-CompartirIgual - CC BY-SA</option>
                  <option [value]="'CC BY-ND'">Reconocimiento-SinObraDerivada - CC BY-ND</option>
                  <option [value]="'CC BY-NC'">Reconocimiento-NoComercial - CC BY-NC</option>
                  <option [value]="'CC BY-NC-SA'">Reconocimiento-NoComercial-CompartirIgual - CC BY-NC-SA</option>
                  <option [value]="'CC BY-NC-ND'">Reconocimiento-NoComercial-SinObraDerivada - CC BY-NC-ND</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <!-- <button (click)="clearSearch()" style="margin-top: 0.5rem; margin-left: 0.5rem;" type="button" class="btn btn-primary">{{t('clear')}}</button> -->
            </div>
          </form>
        </div>
      </div>
    </div>



  </div>


  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close('cancel')">{{t('cancel')}}</button>
    <button (click)="doFilter()" type="button" class="btn btn-primary">{{t('to_filter')}}</button>
  </div>
</ng-container>